import {
    combineReducers
} from 'redux';
import promptsReducer from './promptsReducer';
import resultsReducer from './resultsReducer';
import filtersReducer from './filtersReducer';
import pollResultsReducer from './pollResultsReducer';
import pollVotesReducer from './pollVotesReducer';

const entitiesReducer = combineReducers({
    prompts: promptsReducer,
    results: resultsReducer,
    filterGroups: filtersReducer,
    pollResults: pollResultsReducer,
    pollVotes: pollVotesReducer,
});

export default entitiesReducer;